import cn from 'classnames';
import { useTheme } from '@direct-frontend/components';

export const useMainTheme = (): string => {
    const theme = useTheme();

    return cn(theme.root, theme.main);
};
